"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _ContentStore = _interopRequireDefault(require("./ContentStore"));

var ContentStoreActions = /*#__PURE__*/function () {
  function ContentStoreActions() {
    (0, _classCallCheck2["default"])(this, ContentStoreActions);
  }

  (0, _createClass2["default"])(ContentStoreActions, null, [{
    key: "addEntity",
    value: function addEntity(entity) {
      _ContentStore["default"].addEntity(entity);
    }
  }, {
    key: "removeEntity",
    value: function removeEntity(id) {
      _ContentStore["default"].removeEntity(id);
    }
  }, {
    key: "finishedAddingEntities",
    value: function finishedAddingEntities() {
      _ContentStore["default"].finishedAddingEntities();
    }
  }]);
  return ContentStoreActions;
}();

var _default = ContentStoreActions;
exports["default"] = _default;